export const PreferenceLabel = ({ label }: { label: string }) => {
  return <span className="w-full md:w-64 mr-2 h-full whitespace-normal md:whitespace-nowrap mb-[2px]">{label}</span>;
};
